import * as React from 'react';

function setRef<T>(ref: React.Ref<T> | undefined, value: T) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref !== null && ref !== undefined) {
    (ref as React.MutableRefObject<T>).current = value;
  }
}

function composeRefs<T>(...refs: (React.Ref<T> | undefined)[]) {
  return (node: T) => {
    refs.forEach((ref) => setRef(ref, node));
  };
}

function useComposedRefs<T>(...refs: (React.Ref<T> | undefined)[]) {
  const currentRefs = React.useRef(refs);
  const prevNode = React.useRef<T | null>(null);
  currentRefs.current = refs;
  return React.useCallback((node: T) => {
    if (node === prevNode.current) return;
    prevNode.current = node;
    currentRefs.current.forEach((ref) => setRef(ref, node));
  }, []);
}

export { composeRefs, useComposedRefs };
